<template>
  <!-- 资质列表 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        :model="{ extTable }"
        :rules="tableRules"
        props
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
          <div class="table_title">获奖情况</div>
          <el-table
            border
            :data="extTable"
            class="ccui-form-child-table"
            max-height="99999"
          >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            fixed>
          </el-table-column>
          <el-table-column prop="awardName" label="奖项名称" min-width="282px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.awardName`"
                :rules="tableRules.awardName"
              >
                <el-input
                  style="width: 262px"
                  v-model="scope.row.awardName"
                  placeholder="请输入"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="awardDescription" label="奖项情况说明" width="563px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.awardDescription`"
                :rules="tableRules.awardDescription"
              >
                <el-input
                  style="width: 543px"
                  v-model="scope.row.awardDescription"
                  placeholder="请输入"
                  clearable
                  maxlength="200"
                />
              </el-form-item>
            </template>
          </el-table-column>
            <el-table-column prop="remark" label="操作" width="100px" fixed="right">
              <template slot-scope="scope">
                <span
                  style="color: red; cursor: pointer"
                  @click="deleteItem(scope)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+添加获奖情况</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getBuildingGradeDict } from "@/api/subcontractor-register";
export default {
  props: {
    extTable: {
      type: Array,
      default: []
    }
  },
  components: {
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: function(time) {
          return false;
        }
      };
    },
  },
  data() {
    return {
      checkOut:false,
      tableRules: {
        awardName: [{ required: true, message: "请输入奖项名称", trigger: "blur" }],
        awardDescription: [{ required: true, message: "请输入奖项情况说明", trigger: "blur" }],
      },
    };
  },
  mounted() {
    getBuildingGradeDict({}).then(res => {
      if (res.data.code === "0") {
        this.qualificationLevel = res.data.data;
      }
    });
  },
  methods: {
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1
        });
      }
    },
    ruleFun() {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut=  true;
        } else {
          this.$refs.extTable.$el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          this.checkOut=  false;
        }
      });
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-table /deep/th.gutter {
  display: table-cell !important;
}
.addBtn {
  cursor: pointer;
  margin: 20px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}
/deep/ .el-input--suffix .el-input__inner {
  // padding-right: 25px;
}
/deep/ .el-input__suffix {
  // right: 0px;
  .el-input__clear {
    width: 23px;
  }
}
.addTabIndex /deep/.el-table {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }

  th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  th:nth-child(4)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(1)>.cell:before{
    content: "";
    margin-right: 5px;
  }
}
.table_title {
  width: 100%;
  line-height: 40px;
  border: 1px solid #EDF2FC;
  border-bottom: 0px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #f8fafd;
}
</style>
